// extracted by mini-css-extract-plugin
export default {"awaitingscoresalert":"mMKFJv9Vz3PMIR7pxA34"};